/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Layout,
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Select,
} from "antd";
import { RollbackOutlined } from "@ant-design/icons";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { postAPI, displayMessage } from "../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../constants/messages";
import { KITCHEN_ITEM_DETAIL, KITCHEN_ITEM_UPDATE } from "../../constants/api";
import { ITEM_UNITS } from "../../constants/constent";

function KitchenItemUpdate() {
  const { Content } = Layout;
  const { id } = useParams();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    getDetail();
  }, []);

  const getDetail = () => {
    setLoading(true);

    const successFn = (res) => {
      if (res.status === true) {
        form.setFieldsValue({
          name: res.data.name,
          unit: res.data.unit,
          opening_stock: res.data.opening_stock,
          reorder_level: res.data.reorder_level,
          expiry_alert_days: res.data.expiry_alert_days,
          remark: res.data.remark,
        });
      } else {
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
      setLoading(false);
    };

    const errorFn = () => {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to get item details");
    };

    postAPI(KITCHEN_ITEM_DETAIL, { id }, successFn, errorFn);
  };

  const updateData = (values) => {
    setLoading(true);

    const payload = {
      id,
      ...values,
    };

    const successFn = (res) => {
      if (res.status === true) {
        displayMessage(SUCCESS_MESSAGE, res.message);
        navigate("/kitchen/item");
      } else {
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
      setLoading(false);
    };

    const errorFn = () => {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to update item");
    };

    postAPI(KITCHEN_ITEM_UPDATE, payload, successFn, errorFn);
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Update Kitchen Item"
          bordered={false}
          extra={
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={updateData}>
              <Row gutter={[16, 16]}>
                <Col span={10}>
                  <Form.Item
                    name="name"
                    label="Item Name"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    name="unit"
                    label="Unit"
                    rules={[{ required: true }]}
                  >
                    <Select placeholder="Select unit">
                      {ITEM_UNITS.map((unit) => (
                        <Select.Option key={unit.value} value={unit.value}>
                          {unit.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* Opening stock NOT editable */}
                <Col span={4}>
                  <Form.Item name="opening_stock" label="Opening Stock">
                    <Input disabled />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    name="reorder_level"
                    label="Low Stock Alert"
                    rules={[{ required: true }]}
                  >
                    <Input type="number" />
                  </Form.Item>
                </Col>

                <Col span={4}>
                  <Form.Item
                    name="expiry_alert_days"
                    label="Expiry alert days"
                    rules={[
                      {
                        required: true,
                        message: "Expiry alert days is required",
                      },
                    ]}
                  >
                    <Input type="number" placeholder="2" />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item name="remark" label="Remark">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item style={{ float: "right" }}>
                    <Button type="primary" htmlType="submit" loading={loading}>
                      Update
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenItemUpdate;
